/* eslint no-process-env:0 */
const _ = require('lodash');
const {
  createFpSignature,
} = require('../appModules/utilities/securityUtilities');
const defaultConfig = require('./env/default.json');
const dev = require('./env/dev.json');
const prod = require('./env/prod.json');
const docker = require('./env/docker.json');
const stage = require('./env/stage.json');


/**
 * Get the current environment
 * @param   {String} env The current environment
 * @returns {JSON} Returns the application configuration
 */
function getEnvironmentConfig(env) {
  return (
    {
      dev,
      stage,
      prod,
      docker,
    }[env] || defaultConfig
  );
}

const appEnv = getEnvironmentConfig(process.env.APP_ENV);
const fpData = createFpSignature(process.env.FP_SECRET);

const port = {
  server: {
    port: process.env.APP_PORT,
  },
};

/**
 * Merges default, env, and custom props
 * @param   {Object} custom This parameter is a custom configuration object.
 * @returns {Object} The environmental configuration of the current build.
 */
module.exports = function(custom = {}) {
  return _.merge({}, defaultConfig, appEnv, custom, port, fpData);
};



// WEBPACK FOOTER //
// ./src/appConfig/AppConfig.js